import React from 'react'
import cn from 'clsx'
import styles from './index.module.css'

type Props = {
  content: string
  noTranslate?: boolean
}

/**
 * A text overflow component that displays text with ellipsis overflow and full content on hover
 * @param content - The text content to display
 * @param noTranslate - Opts the content out of browser translation, for user generated data
 * @returns A span element with text overflow handling and title tooltip
 */
const TextOverflow = ({ content, noTranslate }: Props) => (
  <span
    className={cn('overflow-ellipsis', styles.textOverflow)}
    translate={noTranslate ? 'no' : undefined}
  >
    <span
      className={cn('overflow-ellipsis', styles.textOverflowContent)}
      title={content}
    >
      {content}
    </span>
  </span>
)

export default React.memo<Props>(TextOverflow)
